import makeBasicTheme from '../makeBasicTheme'
const mainColor = "#0095f8"
export default makeBasicTheme(mainColor)